import type { IframeHTMLAttributes } from 'react';

type IframePaymentProps = Omit<IframeHTMLAttributes<HTMLIFrameElement>, 'src' | 'id'> & {
    creditUrl: string;
};

// The Pelecard credit-card iframe, shared by every payment flow that embeds it
// (travel-file receipts, financial document generation, tour-management
// payments). `id="CreditCardFrame"` is load-bearing — Pelecard's postMessage
// result page and the in-app resume flows key off that exact frame id.
export default function IframePayment({ creditUrl, style, ...props }: IframePaymentProps) {
    return (
        <iframe
            id="CreditCardFrame"
            src={creditUrl}
            scrolling="yes"
            allow="payment"
            style={{
                borderRadius: '0.7rem',
                position: 'relative',
                width: '100%',
                height: '600px',
                ...style
            }}
            {...props}
        />
    );
}
